// Messaggi brevi nello stile del sito (al posto di alert()).

import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";
import { IconButton } from "./ui";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const nextId = useRef(1);

  const dismiss = useCallback((id) => setToasts((list) => list.filter((t) => t.id !== id)), []);

  const push = useCallback((kind, message) => {
    const id = nextId.current++;
    setToasts((list) => [...list.filter((t) => t.message !== message), { id, kind, message }].slice(-4));
    setTimeout(() => dismiss(id), kind === "error" ? 8000 : 4500);
  }, [dismiss]);

  const api = useMemo(() => ({
    info: (m) => push("info", m),
    ok: (m) => push("ok", m),
    error: (m) => push("error", m),
  }), [push]);

  return (
    <ToastContext.Provider value={api}>
      {children}
      <div className="sm-toasts" role="status" aria-live="polite">
        {toasts.map((t) => (
          <div key={t.id} className={`sm-toast sm-toast--${t.kind}`}>
            <span>{t.message}</span>
            <IconButton icon="x" label="Chiudi" onClick={() => dismiss(t.id)} />
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
